import {
  IMPORT_SHIFTS_PREVIEW, IMPORT_SHIFTS_PREVIEW_SUCCESS, IMPORT_SHIFTS_PREVIEW_FAILURE,
  IMPORT_SHIFTS, IMPORT_SHIFTS_SUCCESS, IMPORT_SHIFTS_FAILURE,
  CLEAR_SHIFT_IMPORT
} from './mutation-types'
import constant from '../constant'

//
// シフトの Excel 取込（F-SFT-02）
// シフト作成画面の「ダウンロード」Excel（横持ち）を プレビュー → 適用 の2段階で取り込む
//
export default {
  state: {
    shiftImportPreview: null,
    shiftImportResult: null,
    shiftIoNotify: null
  },
  getters: {
    shiftImportPreview: state => {
      return state.shiftImportPreview
    },
    shiftImportResult: state => {
      return state.shiftImportResult
    },
    shiftIoNotify: state => {
      return state.shiftIoNotify
    }
  },
  actions: {
    // 取込プレビュー（DBは更新しない）
    [IMPORT_SHIFTS_PREVIEW] ({dispatch, state, commit}, params) {
      state.shiftImportPreview = null
      state.shiftImportResult = null
      return dispatch('apiPost', {url: '/master/shifts/import/preview', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(IMPORT_SHIFTS_PREVIEW_FAILURE, res.data)
          } else {
            commit(IMPORT_SHIFTS_PREVIEW_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '取込内容の確認に失敗しました。'
        commit(IMPORT_SHIFTS_PREVIEW_FAILURE, {error: message})
      })
    },
    // 取込の適用
    [IMPORT_SHIFTS] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/shifts/import', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(IMPORT_SHIFTS_FAILURE, res.data)
          } else {
            commit(IMPORT_SHIFTS_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '取込に失敗しました。'
        commit(IMPORT_SHIFTS_FAILURE, {error: message})
      })
    }
  },
  mutations: {
    // ダイアログを開いた時・ファイルを選び直した時に前回の結果を捨てる
    [CLEAR_SHIFT_IMPORT] (state) {
      state.shiftImportPreview = null
      state.shiftImportResult = null
      state.shiftIoNotify = null
    },
    [IMPORT_SHIFTS_PREVIEW_FAILURE] (state, data) {
      console.log('IMPORT_SHIFTS_PREVIEW_FAILURE')
      state.shiftIoNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.shiftIoNotify = null
      }, constant.notifyShowTime.long)
    },
    [IMPORT_SHIFTS_PREVIEW_SUCCESS] (state, data) {
      console.log('IMPORT_SHIFTS_PREVIEW_SUCCESS')
      state.shiftImportPreview = data.data
      if (data.callback) {
        data.callback()
      }
    },
    [IMPORT_SHIFTS_FAILURE] (state, data) {
      console.log('IMPORT_SHIFTS_FAILURE')
      state.shiftIoNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.shiftIoNotify = null
      }, constant.notifyShowTime.long)
    },
    [IMPORT_SHIFTS_SUCCESS] (state, data) {
      console.log('IMPORT_SHIFTS_SUCCESS')
      state.shiftImportResult = data.data
      state.shiftIoNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.shiftIoNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-io.js